import { render } from "./index.vue?vue&type=template&id=2cca651d"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "/Users/xiaobiaoza/Desktop/workspace/GIM/WPP/wpp-aigc-aigc-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/basic-layout/water-mark/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2cca651d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2cca651d', __exports__)) {
    console.log('reload')
    api.reload('2cca651d', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=2cca651d", () => {
    console.log('re-render')
    api.rerender('2cca651d', render)
  })

}


export default __exports__